import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { UserMoodOutput } from 'user/model/user-mood.output';
import { UserNoteOutput } from 'user/model/user-note.output';
import { UserMood } from 'user/mood/user-mood';
import { UserNote } from 'user/note/user-note';

@Injectable({ providedIn: 'root' })
export class UserMoodConverterService {
	public userMoodAsEntity(output: UserMoodOutput): UserMood {
		if (!output) {
			return null;
		}

		return new UserMood(
			output.id,
			output.creationTimestamp,
			output.mood,
			output.feelings
		);
	}

	public userMoodsAsEntities(outputs: UserMoodOutput[]): UserMood[] {
		return reject(outputs, isNil).map((output) => this.userMoodAsEntity(output));
	}
}
